<template>
  <div>
    <div class="wrapper">
      <div class="container">
        <header-bar />
        <header-router-bar />
        <transition name="fade" mode="out-in">
          <keep-alive :exclude="excludeList">
            <router-view class="router-view" />
          </keep-alive>
        </transition>
      </div>
      <footer-router />
      <side-nav />
      <!-- <motion-graph/> -->
      <product-hot />
      <my-footer />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import headerBar from "./header-bar.vue";
import headerRouterBar from "./header-router-bar.vue";
import footerRouter from "views/footer-page/footer-router.vue"; //底栏
import sideNav from "_c/app-component/sideNav";
import motionGraph from "./motionGraph.vue"; //动图
import myFooter from "@/components/app-component/my-footer.vue"; //底部footer
import productHot from "./productHot.vue";

export default {
  name: "Home",
  components: {
    headerBar,
    headerRouterBar,
    footerRouter,
    sideNav,
    motionGraph,
    myFooter,
    productHot,
  },
  data() {
    return {
      excludeList: ["leaseDetail", "mallDetail", "palletBankDetail", "shoppingCart", "confirmOrder", "homePage", "e-receipt-notes", "newReturn"], //不缓存的组件name
      userId: "",
      showMenu: true,
      classObj: {
        "body-content": true,
        "body-content-max": false,
      },
    };
  },
  computed: {
    ...mapState("menu", ["cachedMenuList"]),
  },
  mounted() {
    this.userId = sessionStorage.getItem("userId");
  },
  methods: {
    // 退出
    logout() {
      this.$Modal.confirm({
        title: "确定要退出吗？",
        onOk: () => {
          this.pltSession.removeSession();
          if (!this.pltSession.getSession()) {
            this.$router.push("/");
          }
        },
      });
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
      this.classObj["body-content"] = !this.classObj["body-content"];
      this.classObj["body-content-max"] = !this.classObj["body-content-max"];
    },
    closeTag(event, name) {
      this.$store.commit("menu/closeMenu", name);
    },
    clickTag(tag) {
      this.$router.push(tag.path);
      this.$store.commit("menu/checkMenu", tag.title);
    },
  },
};
</script>

<style lang="less" scoped>
@import "./home-page.less";
</style>

